const loadEventTemplates = async (component) => {

  const eventTemplates = await component.fetchEventTemplates()

  component.rawEventTemplates = eventTemplates
}

export default loadEventTemplates
